import React from 'react';

interface Props {
    label: string;
    used: number;
    limit: number;
}

/** Uso de un límite del plan (-1 = ilimitado). */
const UsageBar: React.FC<Props> = ({ label, used, limit }) => {
    const unlimited = limit === -1;
    const percent = unlimited ? 0 : limit === 0 ? 100 : Math.min(100, Math.round((used / limit) * 100));
    const color = unlimited ? 'bg-success' : percent >= 100 ? 'bg-danger' : percent >= 80 ? 'bg-warning' : 'bg-primary';

    return (
        <div className="mb-3">
            <div className="d-flex justify-content-between small mb-1">
                <span className="fw-bold">{label}</span>
                <span className="text-muted">{unlimited ? `${used} · ilimitado` : `${used} de ${limit}`}</span>
            </div>
            <div className="progress" style={{ height: 8 }}>
                <div
                    className={`progress-bar ${color}`}
                    role="progressbar"
                    style={{ width: unlimited ? '100%' : `${percent}%`, opacity: unlimited ? 0.35 : 1 }}
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                />
            </div>
        </div>
    );
};

export default UsageBar;
